import React from "react";
import { Link } from "react-router-dom";
import "./Footer.css";
import Logo from "./Logo";
import { FaWhatsapp } from "react-icons/fa";

function Footer() {
  const handleWhatsAppClick = () => {
    window.open("https://wa.me/919792115599", "_blank"); // +91 97921 15599
  };

  return (
    <footer className="footer">
      {/* Main Footer Content */}
      <div className="footer-content">
        <div className="footer-logo-section">
          <div className="logo">
            <Logo />
          </div>
          <div className="contact-info">
            <div className="contact-item">
              <i className="icon email-icon"></i>
              <span>hello@vaahanbuddy.com</span>
            </div>
            <div className="contact-item address">
              <i className="icon location-icon"></i>
              <div>
                <p>
                  Shop No - 42 First Floor, GDA Commercial Complex, Buddha Vihar
                  Part-A, Taramandal Gorakhpur, U.P. - 273016
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="vertical-divider"></div>

        <div className="footer-links">
          <div className="footer-column">
            <h4>Company</h4>
            <ul>
              <li>
                <Link to="/about">About Us</Link>
              </li>
              <li>
                <Link to="/privacy-policy">Privacy Policy</Link>
              </li>
              <li>
                <Link to="/terms-conditions">Terms & Conditions</Link>
              </li>
              <li>
                <Link to="/contact-form">Contact Us</Link>
              </li>
            </ul>
          </div>

          <div className="footer-column">
            <h4>Services</h4>
            <ul>
              <li>
                <Link to="/checkChallan">Check Challans</Link>
              </li>
              <li>
                <Link to="/carInsurance">Car Insurance</Link>
              </li>
              <li>
                <Link to="/bikeInsurance">Bike Insurance</Link>
              </li>
              <li>
                <Link to="/drivingLicenseRenewal">Driving License</Link>
              </li>
              <li>
                <Link to="/loan">Loans</Link>
              </li>
            </ul>
          </div>

          <div className="footer-column">
            <h4>Quick Links</h4>
            <ul>
              <li>
                <Link to="/searchDetails">Vehicle Search</Link>
              </li>
              <li>
                <Link to="/sellYourCar">Sell Your Car</Link>
              </li>
              <li>
                <Link to="/ownershipTransfer">Ownership Transfer</Link>
              </li>
              <li>
                <Link to="/sitemap">Sitemap</Link>
              </li>
              <li>
                <Link to="/becomePartner">Become a Partner</Link>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Copyright Section - Dark Background */}
      <div className="footer-copyright-section">
        <p className="copyright-text">
          Copyright © 2026, All Rights Reserved By{" "}
          <span className="company-name">Raisclab Advisory LLP</span>
        </p>
      </div>

      {/* Bottom Blue Section with Links and Payment Icons */}
      <div className="footer-bottom-section">
        <div className="footer-bottom-links">
          <Link to="/sitemap">Sitemap</Link>
          <span className="link-divider">|</span>
          <Link to="/about">About Us</Link>
          <span className="link-divider">|</span>
          <Link to="/privacy-policy">Privacy Policy</Link>
        </div>

        <div className="payment-icons">
          <div className="payment-icon visa">
            <span>VISA</span>
          </div>
          <div className="payment-icon mastercard">
            <div className="mc-circles">
              <span className="mc-circle red"></span>
              <span className="mc-circle orange"></span>
            </div>
            <span className="mc-text">mastercard</span>
          </div>
          <div className="payment-icon stripe">
            <span>stripe</span>
          </div>
          <div className="payment-icon discover">
            <span>DISCOVER</span>
          </div>
          <div className="payment-icon paypal">
            <span>pay</span>
          </div>
        </div>
      </div>

      {/* WhatsApp Floating Button */}
      <button className="whatsapp-float" onClick={handleWhatsAppClick} aria-label="Contact us on WhatsApp">
        <FaWhatsapp className="whatsapp-icon" />
      </button>
    </footer>
  );
}

export default Footer;
